// [RGM] 2026-09-17 (reporte Rafael: "en pagos… estado, entidad y tipo aún sale
// en números en grilla"): etiquetas de los combos GX de pago, réplica de los
// textos del filtro de la grilla en pagoww.cs (A298PagoEntidad / A304PagoTipo).
export const ENTIDAD_PAGO: Record<number, string> = {
  1: 'Western Union', 2: 'Money Gram', 3: 'Vigo', 4: 'Afex', 5: 'Bancolombia',
  6: 'Giros y Finanzas', 7: 'Gane - Super Giros', 8: 'Efecty', 9: 'Cybertronica',
  10: 'PayU', 11: 'PayPal', 12: 'Online', 13: 'Wompi',
}

export const TIPO_PAGO: Record<number, string> = {
  1: 'Registro', 2: 'Mantenimiento', 3: 'Impresora - WhatsApp', 4: 'Asesoría Personalizada',
  // [RGM] Módulo Facturación (PagoTipo.ModuloFacturacion = 5): el historial de
  // Mi Cuenta y las grillas de pago lo muestran en texto, no en número.
  5: 'Módulo Facturación',
  // [RGM] 2026-09-29 (pedido Rafael): 6 = solo Tickets de impresión, y el 3 se
  // renombró "Impresora - SMS" → "Impresora - WhatsApp".
  6: 'Tickets de Impresión',
}
